import React from 'react';
import { SummaryContainer, SummaryContent, Loader } from "./styles";
import { SummaryLabel, SummaryData } from "../../../../../../CommonComponents/commonStyles";
import formatter from '../../../../../../utils/formatter';
import loaderIcon from "../../../../../../assets/icons/loader.gif";

const Summary = (props) => {
    const { accountName, accountId, currentBalance, availableBalance } = props
    return (
        <SummaryContainer data-test="summary-container">
            <SummaryContent accountWrapper>
                <SummaryLabel accountWrapper isWordBreak>{accountName}</SummaryLabel>
                <SummaryData accountWrapper>{accountId}</SummaryData>
                {!(accountName && accountId) && <Loader data-test="loader" alignLoader src={loaderIcon} alt='loader'/>}
            </SummaryContent>
            <SummaryContent>
                <SummaryLabel>Current Balance</SummaryLabel>
                {currentBalance && <SummaryData data-test="current-balance">{formatter({ value: currentBalance.toFixed(2), fieldSuffix: "Dollars" })}</SummaryData>}
                {!currentBalance && <Loader src={loaderIcon} alt='loader'/>}
            </SummaryContent>
            <SummaryContent noBorder>
                <SummaryLabel>Available Balance</SummaryLabel>
                {availableBalance && <SummaryData data-test="available-balance">{formatter({ value: availableBalance.toFixed(2), fieldSuffix: "Dollars" })}</SummaryData>}
                {!availableBalance && <Loader src={loaderIcon} alt='loader'/>}
            </SummaryContent>
        </SummaryContainer>
    );
}

export default Summary;